import React from "react";
import { connect } from "react-redux";
// dev and production config
import Config from "../../config";

// API wrapper for axios
import { API } from "../../api/api";

import useStyles from "./AuthenticateNone.styles";
import logo from "./database.png";

import Button from "@material-ui/core/Button";

const AuthenticateNone = ({ userId }) => {
  const classes = useStyles();

  const onClick = async () => {
    const result = await API.get(
      `/getFile?bucketName=${Config.dataBucket}&filename=userData-${userId}.json`,
      Config.baseURLAdminService
    );

    const userData = result.data;
    userData.auth = { standalone: true };
    const user = {
      reports: Object.values(userData.reports)
        .filter((node) => !(node.isDefault || node.isCommon))
        .reduce((acc, current) => {
          acc[current.id] = current;
          return acc;
        }, {}),
      dashboards: Object.values(userData.dashboards)
        .filter((node) => !(node.isDefault || node.isCommon))
        .reduce((acc, current) => {
          acc[current.id] = current;
          return acc;
        }, {}),
      profiles: Object.values(userData.profiles)
        .filter((node) => !(node.isDefault || node.isCommon))
        .reduce((acc, current) => {
          acc[current.id] = current;
          return acc;
        }, {}),
    };

    // reconstruct user data
    const updated = {
      ...userData,
      reports: user.reports,
      dashboards: user.dashboards,
      profiles: user.profiles,
    };
    API.post(
      `/saveFile?bucketName=${Config.dataBucket}&filename=userData-${userId}.json`,
      Config.baseURLAdminService,
      updated
    );
    window.location.reload();
    return false;
  };
  return (
    <>
      <div className={classes.root}>
        <div className={classes.block}>
          <img className={classes.logo} src={logo} alt="Logo" width={40} />
          <span className={classes.text}>Standalone mode</span>
          <Button className={classes.button} variant="contained" color="primary" onClick={onClick}>
            Start
          </Button>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({ userId: state.cognito.username });

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticateNone);
